import { render } from "./Mycenter.vue?vue&type=template&id=552c8aed&scoped=true"
import script from "./Mycenter.vue?vue&type=script&lang=js"
export * from "./Mycenter.vue?vue&type=script&lang=js"

import "./Mycenter.vue?vue&type=style&index=0&id=552c8aed&lang=scss"
import "./Mycenter.vue?vue&type=style&index=1&id=552c8aed&lang=scss&scoped=true"

import exportComponent from "E:\\vueWeb\\official\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-552c8aed"]])

export default __exports__